import type { ReactNode } from 'react';
import { Bell, Check } from 'lucide-react';
import { WEATHER_BTN_DISMISS, WEATHER_BTN_SUBSCRIBE, WEATHER_BTN_SUBSCRIBED } from './weatherDesign';

interface WeatherSubscribeFooterProps {
  isSubscribed: boolean;
  onSubscribe: () => void;
  dismissLabel: string;
  onDismiss: () => void;
  /** Optional link or tertiary action below dismiss (e.g. “See full forecast”). */
  extra?: ReactNode;
}

/** Stacked subscribe + dismiss actions — full width on all screen sizes. */
export function WeatherSubscribeFooter({
  isSubscribed,
  onSubscribe,
  dismissLabel,
  onDismiss,
  extra,
}: WeatherSubscribeFooterProps) {
  return (
    <div className="mt-4 flex flex-col gap-2">
      {isSubscribed ? (
        <span
          className={WEATHER_BTN_SUBSCRIBED}
          aria-label="Subscribed to daily weather forecast"
        >
          <Check size={16} aria-hidden />
          Subscribed to daily forecast
        </span>
      ) : (
        <button
          type="button"
          onClick={onSubscribe}
          aria-label="Subscribe for daily weather forecast emails"
          className={WEATHER_BTN_SUBSCRIBE}
        >
          <Bell size={16} className="shrink-0" aria-hidden />
          Subscribe for daily forecast
        </button>
      )}
      <button type="button" onClick={onDismiss} className={WEATHER_BTN_DISMISS}>
        {dismissLabel}
      </button>
      {extra}
    </div>
  );
}
